

type FooterProp = {
  showLogo?: boolean;
  showText?: boolean;
};

const Footer = ({ showText, showLogo }: FooterProp) => {
  return (
    <div className='flex items-center justify-center py-6'>
      {showLogo && (
        <img src='/tim_logo.svg' alt='Logo da TIM' className='mr-4 w-20 opacity-80' />
      )}

      {showText && (
        <div className='flex flex-col items-center gap-1.5'>
          <img src='/tim_logo.svg' alt='Logo da TIM' className='w-20 opacity-80' />
          <p className='text-xs text-gray-400'>Representantes TIM</p>
        </div>
      )}
    </div>
  );
};

export default Footer;
